// extracted by mini-css-extract-plugin
export default {"cnvs":"canvasVideoPlayer__cnvs__WFv0d","video":"canvasVideoPlayer__video__vn_nW"};